// extracted by mini-css-extract-plugin
export default {"recaptcha":"G5tUx4idpU63aumjw5hx"};